import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as transformReducer from "containers/Dataset/reducer";
import * as uploadReducer from "containers/Upload/reducer";

import AdvancedModels from "components/UnifiedProject/AdvancedModels/AdvancedModels";

class AdvancedModelsContainer extends React.PureComponent {
  render() {
    return <AdvancedModels {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateOutcome: (outcome) => dispatch(setupReducer.updateOutcome(ownProps.id, outcome)),
  addField: (extra) => dispatch(transformReducer.addSpecializedAIField(ownProps.id, extra)),
  updateField: (index, update) => dispatch(transformReducer.updateSpecializedAIField(ownProps.id, index, update)),

  updateDatasetHeaders: (headers) => dispatch(uploadReducer.updateDatasetHeaders(headers)),
  updateDatasetRows: (rows) => dispatch(uploadReducer.updateDatasetRows(rows)),
  updateClassifiers: (classifiers) => dispatch(uploadReducer.updateClassifiers(classifiers)),
  updateClassifierName: (classifierName) => dispatch(uploadReducer.updateClassifierName(classifierName)),
  updateIsImageOpen: (isImageOpen) => dispatch(uploadReducer.updateIsImageOpen(isImageOpen)),
  updateModelOutcomeColumn: (modelOutcomeColumn) =>
    dispatch(uploadReducer.updateModelOutcomeColumn(modelOutcomeColumn)),
  setupAI: () => dispatch(uploadReducer.setupAI()),
  buildAI: () => dispatch(uploadReducer.buildAI())
});

const mapStateToProps = (state, ownProps) => {
  const dataset = setupReducer.getDatasetFromSetup(state, ownProps.id);
  const fields = transformReducer.getSpecializedAIFields(state, ownProps.id);

  return {
    dataset: dataset,
    fields: fields,

    datasetRows: uploadReducer.getDatasetRows(state),
    datasetHeaders: uploadReducer.getDatasetHeaders(state),

    classifiers: uploadReducer.getClassifiers(state),
    classifierName: uploadReducer.getClassifierName(state),

    combinedDatasetId: uploadReducer.getCombinedDatsetId(state),
    combinedProjectId: uploadReducer.getCombinedProjectId(state),
    combinedProject: uploadReducer.getCombinedProject(state),

    isImageOpen: uploadReducer.getIsImageOpen(state),

    modelOutcomeColumn: uploadReducer.getModelOutcomeColumn(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(AdvancedModelsContainer);
